export { FaqPage } from "./FaqPage"
